module.exports = __webpack_public_path__ + "img/shareButton.8e79af8f.png";